// NOTE
// It contains user information
// through /user endpoint
import {
	READ_USER,
	CREATE_USER,
	UPDATE_USER,
	DELETE_USER,
	REQUEST_OTP,
	SUCCESS_OTP,
	REVOKE_OTP
} from '../config/actionTypes';

const INITIAL_OTP_OBJECT = {
	requesting: false,
	requested: false,
	error: '',
	secret: '',
	activated: false
};

const initialState = {
	balance: {
		xht_balance: 0,
		xht_available: 0
	},
	crypto_wallet: {},
	email: '',
	verification_level: 1,
	id: 0,
	otp: INITIAL_OTP_OBJECT,
	otp_enabled: false
};

const UserReducer = (state = initialState, action) => {
	const { data } = action;
	switch (action.type) {
		case READ_USER:
			return { ...data };
		case CREATE_USER:
			return { ...state };
		case UPDATE_USER:
			const newData = { ...state, ...data };
			return newData;
		case DELETE_USER:
			return { ...state };
		case REQUEST_OTP:
			return {
				...state,
				otp: {
					...INITIAL_OTP_OBJECT,
					requested: true,
					secret: data.secret
				}
			};
		case SUCCESS_OTP:
			return {
				...state,
				otp: {
					...state.otp,
					activated: true
				}
			};
		case REVOKE_OTP:
			return {
				...state,
				otp: INITIAL_OTP_OBJECT,
				otp_enabled: false
			};
		default:
			return state;
	}
};

export default UserReducer;
